import React from "react";

import PropTypes from 'prop-types';

import { useCarsState } from "../providers/CarsProvider";

import AddIcon from "./icons/AddIcon";

import TrashIcon from "./icons/TrashIcon";

import FloppyDiskIcon from "./icons/FloppyDiskIcon";

import { deleteConfiguration, patchConfiguration, postConfiguration } from "../api/cars";

import ListIcon from "./icons/ListIcon";

import { NavLink } from "react-router-dom";

import BookmarkIcon from "./icons/BookmarkIcon";

import ArrowRightIcon from "./icons/ArrowRightIcon";

const ConfigurationsModule = ( { car, api, open, onSetOpen } ) => {

    const [ carsState, carsDispatch ] = useCarsState();

    const getScreenshot = ( callback ) => {

        if( api ){

            api.getScreenShot( 120, 120, 'image/jpeg', ( error, image ) => {

                if( !error ){

                    callback( image )
                } else callback( null )
            } )
        } else callback( null )
    }

    return (
        <div tabIndex={ 10 } className="pos-fixed tr-0 text-white p-1 z-6 overflow-hidden h-100 d-flex flex-column" style={{gap:4}} >

            <div onClick={ () => { onSetOpen( !open ); } } className="d-flex align-items-center rounded-4" style={{ justifyContent:'space-around', padding:'10px 8px', gap:10, background: "#99999966" }}>

                <button >{ open ? <ArrowRightIcon /> : <BookmarkIcon /> }</button>

                <span className="small">MY BUILDS</span>

                { open && <button className="text-hover-admin-accent" onClick={ e => {

                    e.stopPropagation();

                    getScreenshot( image => {

                        postConfiguration( 'Untitled Configuration', car, image, carsState.currentConfiguration ).then( data => {

                            carsDispatch( { type: "addConfiguration", data } );
                        } );
                    } )
                } } ><AddIcon /></button> }
            </div>

            <div className="flex-grow-1 overflow-y-auto" style = { { display: open ? 'flex' : 'none' } }>

                <div style={{width:124, gap:4}} className="d-flex flex-column">

                    { carsState.configurationsList.map( ( config ) => {

                        let selected = carsState.currentConfiguration.id == config.id;

                        return <div className={`w-100 lh-0 pos-rel rounded-4 ${ selected ? 'brdr-admin-secondary' : 'brdr-gray'}`} style = { { border: "2px solid", gap: 10 } } onClick={ () => {

                            carsDispatch( { type: "setCurrentConfiguration", id: config.id, data: { ...config.data } } );

                        }} key = { `confi-${ config.id }` } >

                            <img style={{ width:'100%', height:120, objectFit:'cover' }} src={ config.image } />

                            { selected && <div className="pos-abs z-1 d-flex align-items-center" style={{borderRadius:4, backgroundColor:"#CCCCCC66", padding:6, bottom:0, left:0, gap:6}}>

                                <button onClick={ e => { 

                                    e.stopPropagation(); 

                                    getScreenshot( image => {

                                        patchConfiguration( config.id, { car, 'imageBase64': image , data: { ...carsState.currentConfiguration } } ).then( data => {

                                            carsDispatch( { type: "saveConfiguration", data } );
                                        } )
                                    } )

                                }}><FloppyDiskIcon style={{fontSize:15, marginTop:2}} /></button>

                                <NavLink onClick={ e => e.stopPropagation() } to={`/cars/${car}/${config.id}`} ><ListIcon /></NavLink>

                                <button onClick={ e=>{ 

                                    e.stopPropagation(); 

                                    deleteConfiguration( config.id ).then( data => {

                                        carsDispatch({type: "deleteConfiguration", id: data.id });
                                    } )
                                }}><TrashIcon /></button>
                            </div> }
                        </div>

                    } ) }
                </div>
            </div>
        </div>
    )
}

ConfigurationsModule.propTypes = {
    car: PropTypes.number.isRequired,
    api: PropTypes.object,
    open: PropTypes.bool,
    onSetOpen: PropTypes.func.isRequired
}

export default ConfigurationsModule